import { render, staticRenderFns } from "./TextAndImageWidget.vue?vue&type=template&id=1e7f40c5&"
import script from "./TextAndImageWidget.vue?vue&type=script&lang=js&"
export * from "./TextAndImageWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e7f40c5')) {
      api.createRecord('1e7f40c5', component.options)
    } else {
      api.reload('1e7f40c5', component.options)
    }
    module.hot.accept("./TextAndImageWidget.vue?vue&type=template&id=1e7f40c5&", function () {
      api.rerender('1e7f40c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/TextAndImageWidget.vue"
export default component.exports